import { getPlanMap } from '@/apis';
import { logger } from '@/utils/log';
import { getVendorsProducts } from './vendor-product';

async function _getVendorsProducts() {
  try {
    if (window.campaignFlags?.enableHardware4Online) {
      return getVendorsProducts() || Promise.resolve(null)
    }
    return Promise.resolve(null)
  } catch (error) {
    logger.error('getVendorsProducts error', error);
    return Promise.resolve(null)
  }
}

async function getAllProductInfo() {
  const [planMap, vendorsData] = await Promise.all([
    getPlanMap(),
    _getVendorsProducts()
  ]
  ).then(([zoomPlansRes, vendorsRes]) => {
    const { result = {} } = zoomPlansRes;
    result.__vendorsData = vendorsRes
    logger.debug('venders-data-loaded', vendorsRes)
    return [result, vendorsRes]
  })

  return {
    planMap,
    vendorsData
  }
}

export {
  getAllProductInfo
}
